import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { MDBAlert, MDBBtn, MDBModalFooter } from "mdb-react-ui-kit";
import { deleteACDGroup } from '../../../apiclients/streamsapi_bridge';



const DeleteACDQueue = forwardRef((props, ref) => {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();

    async function removeThisGroup(e) {
        try {
            setInternalError(false);
            let deleteGrpReponse = await deleteACDGroup(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.groupId);
            let delInfo = await deleteGrpReponse.json();
            if (deleteGrpReponse.status == 200) {
                if (delInfo.status == 'success') {
                    localStorage.setItem("s_message", delInfo.message);
                } else {
                    localStorage.setItem("f_message", delInfo.message);
                }
            } else if (delInfo.status == 400) {
                localStorage.setItem("f_message", delInfo?.message?.errors?.[0]?.message ?? delInfo?.message);
            } else if (delInfo.status == 500) {
                setInternalError(true);
            }
            window.location.href = "/acdQueues";
            props.onClose();
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }

    return (
        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}
            <div>
                <span className="phrecording">{t("RemoveACDtxt")}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => removeThisGroup(e)}>
                    {t("remove")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisGroup(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
        </>
    );
});

export default DeleteACDQueue
